import { ThemeProvider } from '@mui/material/styles'
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import defaultTheme from 'assets/styles'
import { Routes } from './routers'

const App: React.FC = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <Router>
        <Routes />
      </Router>
    </ThemeProvider>
  )
}

export default App
